// Parse the streamed Markdown answer into the section shape AnswerDisplay expects.
const HEADERS = [
  { key: "simple_answer", match: /simple answer/i },
  { key: "what_it_means", match: /what it means/i },
  { key: "when_to_contact_doctor", match: /when to contact a doctor/i },
  { key: "get_urgent_help", match: /get urgent help/i },
];

export function parseSections(markdown) {
  const out = {
    simple_answer: "",
    what_it_means: "",
    when_to_contact_doctor: "",
    get_urgent_help: "",
    note: null,
  };
  if (!markdown) return out;

  const clean = (s) =>
    s
      .replace(/\*\*/g, "")
      .replace(/^[-*]\s+/gm, "• ")
      .trim();

  const lines = markdown.split("\n");
  let current = "simple_answer"; // text before first header belongs here
  const buckets = { simple_answer: [] };

  for (const raw of lines) {
    const headerMatch = raw.match(/^#{1,4}\s+(.*)$/);
    if (headerMatch) {
      const title = headerMatch[1];
      const found = HEADERS.find((h) => h.match.test(title));
      current = found ? found.key : "_ignore";
      if (!buckets[current]) buckets[current] = [];
      continue;
    }
    if (!buckets[current]) buckets[current] = [];
    buckets[current].push(raw);
  }

  for (const key of Object.keys(out)) {
    if (buckets[key]) out[key] = clean(buckets[key].join("\n"));
  }
  return out;
}
